import { render, staticRenderFns } from "./ProxiesPage.vue?vue&type=template&id=d0c11ed2"
import script from "./ProxiesPage.vue?vue&type=script&lang=js"
export * from "./ProxiesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports